import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, QrCode, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, apiError } from "@/lib/api";

export default function QrTab() {
  const [stations, setStations] = useState(null);
  const [qrs, setQrs] = useState({});
  useEffect(() => { api.get("/admin/stations").then((r) => setStations(r.data)); }, []);

  const gen = async (sid) => {
    try {
      const r = await api.get("/admin/qr", { params: { station_id: sid, base: window.location.origin } });
      setQrs((q) => ({ ...q, [sid]: r.data }));
    } catch (e) { toast.error(apiError(e)); }
  };
  const copy = (url) => { navigator.clipboard.writeText(url); toast.success("Link copied"); };

  if (!stations) return <Loader2 className="animate-spin text-purple-400" />;
  return (
    <div>
      <p className="text-sm text-slate-400 mb-4">Generate a QR code for each station. Print & place it on the desk — customers scan to order food & drinks straight to that station.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {stations.map((st) => (
          <div key={st.id} className="glass rounded-2xl p-4 text-center" data-testid={`qr-station-${st.id}`}>
            <p className="font-display font-bold mb-3">{st.name}</p>
            {qrs[st.id] ? (
              <div>
                <img src={qrs[st.id].qr} alt="QR" className="w-40 h-40 mx-auto rounded-xl bg-white p-2" />
                <p className="text-[10px] text-slate-500 break-all mt-2 font-mono">{qrs[st.id].url}</p>
                <div className="flex gap-2 justify-center mt-2">
                  <a href={qrs[st.id].qr} download={`${st.name}-qr.png`}><Button size="sm" className="h-8 bg-purple-600 hover:bg-purple-500">Download</Button></a>
                  <Button size="sm" variant="outline" onClick={() => copy(qrs[st.id].url)} className="h-8 border-purple-500/30 bg-transparent"><Copy size={13} /></Button>
                </div>
              </div>
            ) : (
              <Button data-testid={`gen-qr-${st.id}`} onClick={() => gen(st.id)} className="h-10 bg-purple-600 hover:bg-purple-500"><QrCode size={15} /> Generate QR</Button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
